module.exports = __webpack_public_path__ + "static/img/us.ae656592.svg";